import { status } from 'constants/general';

export const initialCommonState = {
  context: '',
  citiesList: {
    status: status.SHOULD_CALL_API,
    details: [],
  },
  firebaseConfig: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
};

export const initialGeneralState = {
  registerFormSubmission: {
    status: status.SHOULD_CALL_API,
  },
};

export const initialOrderState = {
  getAddressInfo: {
    status: status.SHOULD_CALL_API,
    details: [],
  },
  addAddressInfo: {
    status: status.SHOULD_CALL_API,
  },
  searchProductsInfo: {
    status: status.SHOULD_CALL_API,
    details: {},
  },
  submitOrderBulkInfo: {
    status: status.SHOULD_CALL_API,
    details: [],
  },
};

export const initialAccountManagementState = {
  requestOtpInfo: {
    status: status.SHOULD_CALL_API,
  },
  signWithOtpInfo: {
    status: status.SHOULD_CALL_API,
  },
  loginInfo: {
    status: status.SHOULD_CALL_API,
  },
};
